// 彩云天气key
const weatherKey = '2VSy6awUXdk630EH'

// 风向
const getChineseWindDirection = angle => {
    const windData = [
        { direction: '北', symbol: 'N', centerAngle: 0, range: [348.76, 11.25] }, // 正北（跨0°）
        { direction: '北东北', symbol: 'NNE', centerAngle: 22.5, range: [11.26, 33.75] }, // 顺时针22.5°
        { direction: '东北', symbol: 'NE', centerAngle: 45, range: [33.76, 56.25] }, // 顺时针45°
        { direction: '东东北', symbol: 'ENE', centerAngle: 67.5, range: [56.26, 78.75] }, // 顺时针67.5°
        { direction: '东', symbol: 'E', centerAngle: 90, range: [78.76, 101.25] }, // 顺时针90°（正东）
        { direction: '东东南', symbol: 'ESE', centerAngle: 112.5, range: [101.26, 123.75] }, // 顺时针112.5°
        { direction: '东南', symbol: 'SE', centerAngle: 135, range: [123.76, 146.25] }, // 顺时针135°
        { direction: '南东南', symbol: 'SSE', centerAngle: 157.5, range: [146.26, 168.75] }, // 顺时针157.5°
        { direction: '南', symbol: 'S', centerAngle: 180, range: [168.76, 191.25] }, // 顺时针180°（正南）
        { direction: '南西南', symbol: 'SSW', centerAngle: 202.5, range: [191.26, 213.75] }, // 顺时针202.5°
        { direction: '西南', symbol: 'SW', centerAngle: 225, range: [213.76, 236.25] }, // 顺时针225°
        { direction: '西西南', symbol: 'WSW', centerAngle: 247.5, range: [236.26, 258.75] }, // 顺时针247.5°
        { direction: '西', symbol: 'W', centerAngle: 270, range: [258.76, 281.25] }, // 顺时针270°（正西）
        { direction: '西西北', symbol: 'WNW', centerAngle: 292.5, range: [281.26, 303.75] }, // 顺时针292.5°
        { direction: '西北', symbol: 'NW', centerAngle: 315, range: [303.76, 326.25] }, // 顺时针315°
        { direction: '北西北', symbol: 'NNW', centerAngle: 337.5, range: [326.26, 348.75] } // 顺时针337.5°
    ]

    // 角度归一化：确保值落在0~360°区间（处理负数/超360的情况）
    const normalizedAngle = ((angle % 360) + 360) % 360

    // 匹配对应风向区间
    const obj =
        windData.find(item => {
            const [min, max] = item.range
            // 正北区间跨0°，特殊处理：≥348.76 或 ≤11.25 都算正北
            return item.direction === '北' ? normalizedAngle >= min || normalizedAngle <= max : normalizedAngle >= min && normalizedAngle <= max
        }) || null

    return obj.direction
}

const getDescription = kmh => {
    const windData = [
        { level: 0, kmhMin: 0, kmhMax: 1, msMin: 0, msMax: 0.3, desc: '无风' },
        { level: 1, kmhMin: 1, kmhMax: 5, msMin: 0.3, msMax: 1.6, desc: '微风徐徐' },
        { level: 2, kmhMin: 5, kmhMax: 11, msMin: 1.6, msMax: 3.4, desc: '清风' },
        { level: 3, kmhMin: 11, kmhMax: 19, msMin: 3.4, msMax: 5.5, desc: '树叶摇摆' },
        { level: 4, kmhMin: 19, kmhMax: 28, msMin: 5.5, msMax: 8.0, desc: '树枝摆动' },
        { level: 5, kmhMin: 28, kmhMax: 38, msMin: 8.0, msMax: 10.8, desc: '风力强劲' },
        { level: 6, kmhMin: 38, kmhMax: 49, msMin: 10.8, msMax: 13.9, desc: '风力强劲' },
        { level: 7, kmhMin: 49, kmhMax: 61, msMin: 13.9, msMax: 17.2, desc: '风力超强' },
        { level: 8, kmhMin: 61, kmhMax: 74, msMin: 17.2, msMax: 20.8, desc: '狂风大作' },
        { level: 9, kmhMin: 74, kmhMax: 88, msMin: 20.8, msMax: 24.5, desc: '狂风呼啸' },
        { level: 10, kmhMin: 88, kmhMax: 102, msMin: 24.5, msMax: 28.5, desc: '暴风毁树' },
        { level: 11, kmhMin: 102, kmhMax: 117, msMin: 28.5, msMax: 32.7, desc: '暴风毁树' },
        { level: 12, kmhMin: 117, kmhMax: 133, msMin: 32.7, msMax: 37.0, desc: '飓风' },
        { level: 13, kmhMin: 133, kmhMax: 149, msMin: 37.0, msMax: 41.5, desc: '台风' },
        { level: 14, kmhMin: 149, kmhMax: 166, msMin: 41.5, msMax: 46.2, desc: '强台风' },
        { level: 15, kmhMin: 166, kmhMax: 183, msMin: 46.2, msMax: 51.0, desc: '强台风' },
        { level: 16, kmhMin: 183, kmhMax: 201, msMin: 51.0, msMax: 56.1, desc: '超强台风' },
        { level: 17, kmhMin: 201, kmhMax: 220, msMin: 56.1, msMax: 61.3, desc: '超强台风' }
    ]

    if (typeof kmh !== 'number' || kmh < 0) {
        throw new Error('风速必须是大于等于0的数字')
    }

    const matched = windData.find(item => {
        return kmh >= item.kmhMin && kmh <= item.kmhMax
    })

    if (!matched) {
        return null
    }

    const data = {
        level: matched.level + '级',
        kmhRange: `${matched.kmhMin}-${matched.kmhMax} km/h`,
        msRange: `${matched.msMin}-${matched.msMax} m/s`,
        desc: matched.desc
    }

    return data.level
}

// 天气现象
const getWeatherDescription = code => {
    const weatherMap = {
        CLEAR_DAY: '晴（白天）',
        CLEAR_NIGHT: '晴（夜间）',
        PARTLY_CLOUDY_DAY: '多云（白天）',
        PARTLY_CLOUDY_NIGHT: '多云（夜间）',
        CLOUDY: '阴',
        LIGHT_HAZE: '轻度雾霾',
        MODERATE_HAZE: '中度雾霾',
        HEAVY_HAZE: '重度雾霾',
        LIGHT_RAIN: '小雨',
        MODERATE_RAIN: '中雨',
        HEAVY_RAIN: '大雨',
        STORM_RAIN: '暴雨',
        FOG: '雾',
        LIGHT_SNOW: '小雪',
        MODERATE_SNOW: '中雪',
        HEAVY_SNOW: '大雪',
        STORM_SNOW: '暴雪',
        DUST: '浮尘',
        SAND: '沙尘',
        WIND: '大风'
    }

    return weatherMap[code] || '未知'
}

const getWeatherIcon = code => {
    const weatherMap = {
        CLEAR_DAY: 'qing',
        CLEAR_NIGHT: 'qing_ye',
        PARTLY_CLOUDY_DAY: 'duoyun',
        PARTLY_CLOUDY_NIGHT: 'duoyun_yejian',
        CLOUDY: 'ying',
        LIGHT_HAZE: 'qingdu-wumai',
        MODERATE_HAZE: 'zhongdu-wumai',
        HEAVY_HAZE: 'zhongdu-error-wumai',
        LIGHT_RAIN: 'xiaoyu',
        MODERATE_RAIN: 'zhongyu',
        HEAVY_RAIN: 'dayu',
        STORM_RAIN: 'baoyu',
        FOG: 'wu',
        LIGHT_SNOW: 'xiaoxue',
        MODERATE_SNOW: 'zhongxue',
        HEAVY_SNOW: 'daxue',
        STORM_SNOW: 'baoxue',
        DUST: 'fucheng',
        SAND: 'shacheng',
        WIND: 'dafeng'
    }

    return new URL(`../assets/img/weather/${weatherMap[code]}.png`, import.meta.url).href
}

export { weatherKey, getChineseWindDirection, getDescription, getWeatherDescription, getWeatherIcon }
